import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DemoAutoLogin: React.FC = () => {
  const authContext = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    const autoLogin = async () => {
      try {
        setStatus('loading');
        // Credenciais de demonstração
        const email = 'twpeltda@gmail.com';
        const senha = 'ThinkWay';
        
        await authContext.signIn(email, senha);
        setStatus('success');
        
        // Redireciona para o dashboard após 1 segundo
        setTimeout(() => {
          navigate('/tw/dashboard');
        }, 1000);
      } catch (err: any) {
        console.error('Erro no auto-login:', err);
        setStatus('error');
        
        // Redireciona para login normal após 3 segundos em caso de erro
        setTimeout(() => {
          navigate('/tw/login');
        }, 3000);
      }
    };

    autoLogin();
  }, [authContext, navigate]);

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: '100vh',
        backgroundImage: 'url("/landing-page-background.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          backgroundColor: '#1F2C40',
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.05)',
          p: 6
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3
          }}
        >
          <Box
            component="img"
            src="/logo192.png"
            alt="ThinkWay"
            sx={{
              width: 120,
              height: 'auto',
              filter: 'brightness(1.2)'
            }}
          />

          {status === 'loading' && (
            <>
              <CircularProgress size={48} sx={{ color: 'white' }} />
              <Typography
                variant="h5"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  textAlign: 'center'
                }}
              >
                Entrando na demonstração...
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  textAlign: 'center'
                }}
              >
                Por favor, aguarde um momento
              </Typography>
            </>
          )}

          {status === 'success' && (
            <>
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  backgroundColor: '#4caf50',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography sx={{ color: 'white', fontSize: 40 }}>✓</Typography>
              </Box>
              <Typography
                variant="h5"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  textAlign: 'center'
                }}
              >
                Login realizado com sucesso!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  textAlign: 'center'
                }}
              >
                Redirecionando para o dashboard...
              </Typography>
            </>
          )}

          {status === 'error' && (
            <>
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  backgroundColor: '#f44336',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography sx={{ color: 'white', fontSize: 40 }}>✕</Typography>
              </Box>
              <Typography
                variant="h5"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  textAlign: 'center'
                }}
              >
                Erro ao fazer login
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  textAlign: 'center'
                }}
              >
                Redirecionando para a página de login...
              </Typography>
            </>
          )}
        </Box>
      </Container>
    </Container>
  );
};

export default DemoAutoLogin;
